import { THOUSANDS_REGEX } from '../../constants';

const NON_DIGIT_REGEX = /[^0-9]/g;

class NumbersOnlyFormatter {
  static tryParse(format) {
    // OF2-T1085: "integer-nonnegative" is the new name; "numbers-only" stays as its legacy alias.
    if (format === 'integer-nonnegative') return new NumbersOnlyFormatter();

    const m = /^numbers-only(-raw)?$/.exec(format);

    return m ? new NumbersOnlyFormatter(!!m[1]) : null;
    // return format === 'numbers-only' ? new NumbersOnlyFormatter() : null;
  }

  /**
   * Shared by apply() and parse(): the digits before the first decimal point, nothing else (no sign).
   * OF2-T1085: the decimals are cut off, not stripped, so 12.75 reads as 12 rather than 1275.
   * Numbers are read without exponent notation (1e21).
   */
  static clean(value) {
    const text =
      typeof value === 'number' ? value.toLocaleString('en-US', { useGrouping: false, maximumFractionDigits: 20 }) : value.toString();

    return text.split('.')[0].replace(NON_DIGIT_REGEX, '');
  }

  constructor(raw = false) {
    this.rawNumber = raw;
  }

  apply(value) {
    if (value === undefined || value === null || value === '') return '';

    const digits = NumbersOnlyFormatter.clean(value);

    if (this.rawNumber) return digits;

    // Insert a comma every 3 digits (display only; parse() saves the bare digits).
    return digits.replace(THOUSANDS_REGEX, ',');
  }

  parse(value) {
    if (value === undefined || value === null || value === '') return value;

    return NumbersOnlyFormatter.clean(value);
  }
}

export default NumbersOnlyFormatter;
